import "bootstrap/dist/css/bootstrap.min.css";
import "loaders.css/loaders.min.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "react-datepicker/dist/react-datepicker.css";
import "./styles/global.scss";
import * as Sentry from "@sentry/react";
import React from "react";
import ReactDOM from "react-dom";
import { registerLocale } from "react-datepicker";
import Fr from "date-fns/locale/fr";
import En from "date-fns/locale/en-GB";
import { Provider } from "react-redux";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { type RootStateI } from "./redux";
import thunkMiddleware from "redux-thunk";
import user from "./redux/reducers/user";
import app from "./redux/reducers/app";
import wheel from "./redux/reducers/wheel";
import saas from "./redux/saas/reducer";
import { QueryClient, QueryClientProvider } from "react-query";
import venue from "./redux/venue";
import controller from "./redux/controller/controller";
import jetpackConfig from "./redux/jetpackConfig";
import customPOSA from "./redux/customPOSA";
import statistics from "./redux/statistics/reducer";
import AppRouterWrapper from "./app/AppRouterWrapper";
import CONFIG from "./model/TSConfig";
import versionMetadata from "./version.json";

if (CONFIG.sentryDSN) {
  Sentry.init({
    dsn: CONFIG.sentryDSN,
    environment: CONFIG.env,
    release: `pro-v3@${versionMetadata.buildMajor}.${versionMetadata.buildMinor}.${versionMetadata.buildRevision}`,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: CONFIG.env === "prod" ? 0.1 : 1.0,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0
  });
} else {
  console.warn("Did not init Sentry because DSN is absent");
}

registerLocale("fr", Fr);
registerLocale("en", En);

const $ = require("jquery");
// @ts-expect-error
window.$ = $;
// @ts-expect-error
window.jQuery = $;
require("bootstrap/dist/js/bootstrap.min");

// Usage in your app
export function initializeStore(initialState?: RootStateI) {
  return createStore(
    combineReducers<RootStateI>({
      user,
      app,
      wheel,
      saas,
      venues: venue,
      controller,
      jetpackConfig,
      customPOSA,
      statistics
    }),
    initialState,
    applyMiddleware(thunkMiddleware)
  );
}

const store = initializeStore();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Disable window focus refetching
      refetchOnMount: true, // Still refetch when component mounts
      refetchOnReconnect: true, // Still refetch when internet reconnects
      staleTime: 30 * 60 * 1000, // Data considered fresh for 5 minutes
      cacheTime: 10 * 60 * 1000 // Keep unused data in cache for 10 minutes
    }
  }
});

ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <AppRouterWrapper />
    </QueryClientProvider>
  </Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
